import React, { useEffect, useState } from 'react';
import MenuMain from '../../MenuMain';
import { FormTipoCursos } from '../../components/FormTipoCursos';
import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function CadastrarCursosPage() {
  const [tipos, setTipos] = useState([]);

  const getTipoCursos = async () => {
    try {
      const respTipo = await api.get(`tipo-cursos`);

      const tiposFormatados = respTipo.data.map((tipo) => ({
        label: tipo.nome,
        value: tipo.id
      }));

      setTipos(tiposFormatados);
    } catch (error) {
      console.log('Erro ao buscar tipos de curso:', error);
    }
  };

  useEffect(() => {
    getTipoCursos();
  }, []);

  const defaultValues = {
    nome: '',
    obs: '',
    sigla: '',
    tipoId: '',
  };

  return (
    <div>
      <MenuMain>
        <FormTipoCursos
          defaultValues={defaultValues}          
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
